import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
      
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        // Exchange session_id for session_token (sets httpOnly cookie)
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Now cookie is set — use checkAuth to fetch user via /api/auth/me
        // This ensures the user state is set properly in the context
        await checkAuth();

        // Clear the hash from URL and navigate to home
        // Use window.history to cleanly remove the hash before navigating
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate, checkAuth]);

  return null;
};

export default AuthCallback;
